// app/adminSL/session/asl_session.js

(function () {
    'use strict';
    var controllerId = 'asl_session';
    angular.module('app').controller(controllerId, ['$rootScope', '$scope', 'common', '$q', 'bootstrap.dialog', '$routeParams', '$uibModal', 'datacontext', 'sectionMenu', 'filterFilter', asl_sessionFn]);

    function asl_sessionFn($rootScope, $scope, common, $q, bDialog, $routeParams, $uibModal, datacontext, sectionMenu, filterFilter) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var logError = getLogFn(controllerId, 'logError');
        var logSuccess = getLogFn(controllerId, 'logSuccess');
        $rootScope.dashview = ""; // Azzera la classe dashview utile solo nelle dashboard

        var vm = this;
        vm.title = 'Sessioni';
        vm.view = 'list';       //Opzione list or detail
        vm.setView = setView;
        vm.sectionMenu = sectionMenu.setSection(vm.title);			

        vm.objName = "session"; //Utilizzato per pannello modale
        vm.showObjPanel = false;
        vm.record = {};
        vm.records = [];
        vm.tests = [];
        vm.classi = [];
        vm.countRecords = 0;
        vm.index = 0;
        vm.custom = false;

        vm.addDisabled = true;
        vm.exportDisabled = false;
        vm.addTitle = 'Nuova Sessione';
        vm.bAddState = false;
        vm.pageSize = 30;
        vm.page = 1;
        vm.loading = false;

        //Elenco per Ordinamento
        vm.list = {};
        vm.list.ordine = ['classe', 'data decrescente', 'data crescente', 'docente', 'test'];
        vm.ordine = vm.list.ordine[1];
        vm.selectOrdine = function (item) {
            vm.ordine = item;
        };

        //Elenchi dettaglio
        vm.list.allievi = [];
        vm.allieviCount = 0;

        vm.getRecord = getRecord;
        vm.getListAllievi = getListAllievi;        

        //Filtro
        vm.filter = {};        
        vm.fBStato = 0;
        vm.filter.stato = 0;
        vm.fRicerca = "";
        vm.filter.ricerca = "";
                
        //Elenchi per filtri e finestra modale di Create
        vm.test = [];
        
    	//datapicker
        vm.open = function ($event) {
        	$event.preventDefault();
        	$event.stopPropagation();

        	vm.opened = !vm.opened;
        };

        vm.dateOptions = {
        	formatYear: 'yy',
        	startingDay: 1
        };

        vm.format = 'dd/MM/yyyy';

        //Metodi su interfaccia
        vm.cerca = cerca;
        vm.loadMore = getAllByFilter;
        vm.loadAll = getAll;
        vm.get = getRecord;

        //Metodi download documenti
        vm.getRisultatiAlfabetico = getRisultatiAlfabetico;
        vm.getRisultatiPunteggio = getRisultatiPunteggio;
        vm.getRisultatiPerStudente = getRisultatiPerStudente;
        vm.getRiepilogo = getRiepilogo;
        vm.getRiepilogoTest = getRiepilogoTest;

        // ---- ACTIVATE -------
        activate();

        function activate() {
        	var promises = [];
            common.activateController(promises, controllerId)
                    .then(function () {
                        if ($routeParams.SessionId != null) {
                            setView('detail');
                            getRecord($routeParams.SessionId, 0);
                        }
                        if ($routeParams.testId != null) {        //Crea sessione da test
                            setView('detail');
                            getRecord(0, 0);
                            vm.record.testId = $routeParams.testId;
                            datacontext.test_get($routeParams.testId).then(function (data) {
                                vm.record.testTitle = data.title;
                            });                            
                        }
                    });
        }

        //****************************************************
        // METODI 
        //****************************************************
        function setView(view) {
            return vm.view = view;
        }

        function cerca() {
            vm.records = [];
            vm.countRecords = 0;
            vm.page = 1;
            vm.filter.stato = vm.fBStato == null ? 0 : vm.fBStato;            
            vm.filter.ricerca = vm.fRicerca == null ? "" : vm.fRicerca;

            vm.loading = false;
            countByFilter();
            return getAllByFilter();
        }

        function countByFilter() {
            return datacontext.asl_session_countAll(vm.filter.ricerca, vm.filter.stato)
                .then(function (data) {
                    if (data) {
                        vm.countRecords = data;
                    }
                });
        }

        function getAllByFilter() {
            if (vm.loading === true) return;

            if (vm.countRecords == 0) countByFilter();
            else if (vm.countRecords <= vm.records.length) return;

            vm.loading = true;
            return datacontext.asl_session_getAll(vm.pageSize, vm.page, vm.filter.ricerca, vm.filter.stato, vm.ordine)
                .then(function (data) {
                    if (data.constructor === Array) {
                        vm.page++;
                        data.forEach(function (item) {
                            vm.records.push(item);
                        });
                    }
                    vm.loading = false;
                });
            
        }

        function getAll() {
            if (vm.records.length < vm.countRecords) {
                getAllByFilter().then(function () { getAll(); });
            }
        }

        function getRecord(id, index) {
        	return datacontext.session_get(id).then(function (data) {
        		vm.bAddState = false;
                vm.index = index;
                vm.record = data;
                if (vm.record.enabled || vm.record.performed)
            	    vm.minDate = null;
				else
            	    vm.minDate = new Date();

                if ((vm.record.dtOnlyExpected) != null) vm.record.dtOnlyExpected = new Date(vm.record.dtOnlyExpected);

                //Azzera liste
                vm.list.allievi = [];
                vm.allieviCount = 0;
                //Recupero conteggio studenti
                datacontext.studenteSession_countByFilter(id).then(function (count) {                    
                    if (count != null && count > 0)
                        vm.allieviCount = count;
                });

                setView('detail');
          });
        }                

    	//Elenchi Parametri
        function getListAllievi() {
            return datacontext.studenteSession_getAllByFilter(0, 0, vm.record.Id, '', 'nominativo').then(function (data) {
                if(data != null)
                    vm.allieviCount = data.length;                
                return vm.list.allievi = data;                
        	});
        }

        //****************************************************
        // Metodi download documenti
        //****************************************************
        function detectIE() {
            var ua = window.navigator.userAgent;

            var msie = ua.indexOf('MSIE ');
            if (msie > 0) {
                // IE 10 or older => return version number
                return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
            }

            var trident = ua.indexOf('Trident/');
            if (trident > 0) {
                // IE 11 => return version number
                var rv = ua.indexOf('rv:');
                return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
            }

            var edge = ua.indexOf('Edge/');
            if (edge > 0) {
                // IE 12 => return version number
                return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
            }

            // other browser
            return false;
        }

        function getRisultatiAlfabetico() {
            if (vm.spinRisultatiAlfabetico == true)
                return;

            vm.spinRisultatiAlfabetico = true;
            common.$http.get('/edup/report/GetRisultatiAlfabetico?lang=it&sessionId=' + vm.record.Id, { responseType: 'arraybuffer' })
                .then(function (response) {                    
                    var a = document.createElement("a");
                    a.setAttribute('style', 'display:none');

                    document.body.appendChild(a);

                    var file = new Blob([response.data], { type: 'application/pdf' });
                    var fileURL = URL.createObjectURL(file);

                    a.href = fileURL;                    

                    if (detectIE())
                        window.navigator.msSaveBlob(file, vm.record.Id + '_Risultati_alfabetico.pdf');
                    else
                        a.download = vm.record.Id + '_Risultati_alfabetico.pdf';

                    a.click();
                    //window.URL.revokeObjectURL(fileURL);
                    document.body.removeChild(a);

                    vm.spinRisultatiAlfabetico = false;
                })
                .catch(function (message) {
                    vm.spinRisultatiAlfabetico = false;
                    logError('Impossibile scaricare il file');
                });
        }

        function getRisultatiPunteggio() {
            if (vm.spinRisultatiPunteggio == true)
                return;

            vm.spinRisultatiPunteggio = true;
            common.$http.get('/edup/report/getRisultatiPunteggio?lang=it&sessionId=' + vm.record.Id, { responseType: 'arraybuffer' })
                .then(function (response) {
                    var a = document.createElement("a");
                    a.setAttribute('style', 'display:none');

                    document.body.appendChild(a);

                    var file = new Blob([response.data], { type: 'application/pdf' });
                    var fileURL = URL.createObjectURL(file);

                    a.href = fileURL;
                    if (detectIE())
                        window.navigator.msSaveBlob(file, vm.record.Id + '_Risultati_punteggio.pdf');
                    else
                        a.download = vm.record.Id + '_Risultati_punteggio.pdf';
                    a.click();
                    //window.URL.revokeObjectURL(fileURL);
                    document.body.removeChild(a);

                    vm.spinRisultatiPunteggio = false;
                })
                .catch(function (message) {
                    vm.spinRisultatiPunteggio = false;
                    logError('Impossibile scaricare il file');
                });
        }

        function getRisultatiPerStudente() {
            if (vm.spinRisultatiPerStudente == true)
                return;

            vm.spinRisultatiPerStudente = true;
            common.$http.get('/edup/report/GetRisultatiPerStudente?lang=it&sessionId=' + vm.record.Id, { responseType: 'arraybuffer' })
                .then(function (response) {
                    var a = document.createElement("a");
                    a.setAttribute('style', 'display:none');

                    document.body.appendChild(a);

                    var file = new Blob([response.data], { type: 'application/pdf' });
                    var fileURL = URL.createObjectURL(file);

                    a.href = fileURL;
                    if (detectIE())
                        window.navigator.msSaveBlob(file, vm.record.Id + '_Risultati_studenti.pdf');
                    else
                        a.download = vm.record.Id + '_Risultati_studenti.pdf';
                    a.click();                   
                    // window.URL.revokeObjectURL(fileURL);
                    document.body.removeChild(a);

                    vm.spinRisultatiPerStudente = false;
                })
                .catch(function (message) {
                    vm.spinRisultatiPerStudente = false;
                    logError('Impossibile scaricare il file');
                });
        }

        function getRiepilogo() {
            if (vm.spinRiepilogo == true)
                return;

            vm.spinRiepilogo = true;
            common.$http.get('/edup/report/GetRiepilogo?lang=it&sessionId=' + vm.record.Id, { responseType: 'arraybuffer' })
                .then(function (response) {
                    var a = document.createElement("a");
                    a.setAttribute('style', 'display:none');

                    document.body.appendChild(a);

                    var file = new Blob([response.data], { type: 'application/pdf' });
                    var fileURL = URL.createObjectURL(file);

                    a.href = fileURL;
                    if (detectIE())
                        window.navigator.msSaveBlob(file, vm.record.Id + '_Risultati_domande.pdf');
                    else
                        a.download = vm.record.Id + '_Risultati_domande.pdf';
                    a.click();
                    //window.URL.revokeObjectURL(fileURL);
                    document.body.removeChild(a);

                    vm.spinRiepilogo = false;
                })
                .catch(function (message) {
                    vm.spinRiepilogo = false;                    
                    logError('Impossibile scaricare il file');
                });
        }

        function getRiepilogoTest() {
            if (vm.spinRiepilogoTest == true)
                return;

            vm.spinRiepilogoTest = true;
            common.$http.get('/edup/report/GetRiepilogoTest?lang=it&sessionId=' + vm.record.Id, { responseType: 'arraybuffer' })
                .then(function (response) {
                    var a = document.createElement("a");                    
                    a.setAttribute('style', 'display:none');

                    document.body.appendChild(a);
                    
                    var file = new Blob([response.data], { type: 'application/pdf' });
                    var fileURL = URL.createObjectURL(file);                   

                    a.href = fileURL;
                    if (detectIE())
                        window.navigator.msSaveBlob(file, vm.record.Id + '_Griglia_esito.pdf');
                    else
                        a.download = vm.record.Id + '_Griglia_esito.pdf';
                    a.click();
                    //window.URL.revokeObjectURL(fileURL);
                    document.body.removeChild(a);

                    vm.spinRiepilogoTest = false;
                })
                .catch(function (message) {
                    vm.spinRiepilogoTest = false;
                    logError('Impossibile scaricare il file');
                });
        }
    }
})();
